var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { SignaturePopup } from "./SignaturePopup";
import { test_json_data } from "./test_json_data";
import Swal from "sweetalert2";
new SignaturePopup();
var submit_button = document.getElementById("submit_form_button");
if (submit_button) {
    submit_button.addEventListener("click", submit);
}
if (process.env.DEBUG === "true") {
    window.pdf.json_data = test_json_data;
}
function getPdf() {
    return __awaiter(this, void 0, void 0, function () {
        var model, raw, myHeaders, rawResponse, blob, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    model = window.model;
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    raw = JSON.stringify(model.json_data);
                    myHeaders = new Headers();
                    myHeaders.append("Content-Type", "application/json");
                    return [4 /*yield*/, fetch("".concat(process.env.BASE_DOMAIN), {
                            method: "POST",
                            headers: myHeaders,
                            body: raw
                        })];
                case 2:
                    rawResponse = _a.sent();
                    return [4 /*yield*/, rawResponse.blob()];
                case 3:
                    blob = _a.sent();
                    return [2 /*return*/, blob];
                case 4:
                    error_1 = _a.sent();
                    console.log("error generating pdf----->>", error_1);
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    });
}
var isSubmitting = false;
function submit() {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    // Guard against duplicate triggers (double click, click + postMessage, etc.)
                    if (isSubmitting) {
                        return [2 /*return*/];
                    }
                    isSubmitting = true;
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, , 3, 4]);
                    return [4 /*yield*/, doSubmit()];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    isSubmitting = false;
                    // Let the form know the attempt is over (validation failed, error or done)
                    window.postMessage({ type: "action-result", data: "submit-finished" }, "*");
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    });
}
function doSubmit() {
    return __awaiter(this, void 0, void 0, function () {
        var pdf, model, extraQueryParams, withCaptcha, answerUrl, captchaValue, check, body, response, data, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    pdf = window.pdf, model = window.model, extraQueryParams = window.extraQueryParams;
                    withCaptcha = window["withCaptcha"] === "true";
                    answerUrl = window["answerUrl"] || "/save-document/";
                    captchaValue = model.json_data.captchaValue;
                    return [4 /*yield*/, pdf.validate()];
                case 1:
                    check = _a.sent();
                    if (!check) {
                        alert("Please, complete the missing fields");
                        return [2 /*return*/];
                    }
                    if (!captchaValue && withCaptcha) {
                        alert("Please, complete the reCAPTCHA");
                        return [2 /*return*/];
                    }
                    pdf.setLoading(true);
                    _a.label = 2;
                case 2:
                    _a.trys.push([2, 5, 6, 7]);
                    body = JSON.stringify({
                        json_data: __assign(__assign({}, model.json_data), { studentProfileId: model.json_data.studentProfileId || model.profileId, form_id: model.form_id }),
                        extraQueryParams: extraQueryParams
                    });
                    return [4 /*yield*/, fetch(answerUrl, {
                            method: "POST",
                            headers: __assign({ "Content-Type": "application/json", Authorization: "Bearer ".concat(model.token) }, (model.profileId && { "x-profile-id": String(model.profileId) })),
                            body: body
                        })];
                case 3:
                    response = _a.sent();
                    return [4 /*yield*/, response.json()];
                case 4:
                    data = _a.sent();
                    if (!response.ok) {
                        console.error("Error in server:", (data === null || data === void 0 ? void 0 : data.message) || data);
                        showErrorPage((data === null || data === void 0 ? void 0 : data.message) || "Server Internal Error: Cannot create the document.");
                        return [2 /*return*/];
                    }
                    showSuccessPage();
                    return [3 /*break*/, 7];
                case 5:
                    error_2 = _a.sent();
                    console.error("Error in network or exception:", error_2);
                    showErrorPage(error_2.message || "Server Internal Error: Cannot create the document.");
                    return [3 /*break*/, 7];
                case 6:
                    pdf.setLoading(false);
                    return [7 /*endfinally*/];
                case 7: return [2 /*return*/];
            }
        });
    });
}
window.addEventListener("message", function (e) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        if (e.data.type === "action" && e.data.data === "submit") {
            submit();
        }
        return [2 /*return*/];
    });
}); });
function showSuccessPage() {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            Swal.fire({
                icon: "success",
                title: "Form sent",
                text: "The form has been sent to the student document",
                width: "500px"
            }).then(function () {
                //@ts-ignore
                window.location.assign(process.env.BASE_DOMAIN);
                location.reload();
            });
            return [2 /*return*/];
        });
    });
}
function showErrorPage(message) {
    if (message === void 0) { message = ""; }
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            Swal.fire({
                icon: "error",
                title: "Server Internal Error",
                text: message,
                width: "500px"
            }).then(function () {
                //@ts-ignore
                //window.location.assign(process.env.BASE_DOMAIN)
                //location.reload()
            });
            return [2 /*return*/];
        });
    });
}
//# sourceMappingURL=data:application/json;base64,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